import HistoryTree from './HistoryTree';

export default HistoryTree;
